import { render, staticRenderFns } from "./language.vue?vue&type=template&id=27403c4c&scoped=true"
import script from "./language.vue?vue&type=script&lang=js"
export * from "./language.vue?vue&type=script&lang=js"
import style0 from "./language.vue?vue&type=style&index=0&id=27403c4c&prod&scoped=true&lang=css"
import style1 from "./language.vue?vue&type=style&index=1&id=27403c4c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27403c4c",
  null
  
)

export default component.exports